import styled from 'styled-components';

import { BREAKPOINTS } from '../../ui/settings';
import { media, space, rems } from '../../ui/helpers';
import fonts from '../../ui/fonts';
import { colors } from '../../ui/design-tokens';

const Module = styled.div`
  background: ${({ theme }) => theme.background}; 
  color: ${({ theme }) => theme.text};
  padding: ${space(8)} 0;
  position: relative;

  .title {
    ${fonts.titleSM};
    margin-bottom: ${space(4)};
    text-align: center;

  }

  ${media.min('medium')`
    padding: ${space(8)} 0;
    .title {
      ${fonts.titleSM};
    }
  `}
`;

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;

  ${media.min('medium')`
    align-items: initial;
    flex-flow: row wrap;
    justify-content: center;
  `}
`;

const Item = styled.div`
  display: flex;
  flex-direction: column;
  max-width: ${rems(BREAKPOINTS.small)};
  width: 100%;
  position: relative;
  margin-bottom: 2px;

  .top {
    margin-bottom: 2px;
    display: flex;
    flex-direction: column;
    position: relative;

    .icon {
      align-items: center;
      background: ${colors.neutral[100]};
      border-radius: 50%;
      display: flex;
      height: ${rems(40)};
      justify-content: center;
      left: 50%;
      opacity: 0.8;
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
      width: ${rems(40)};
      z-index: 10;

      &:hover {
        cursor: pointer;
      }

      ${media.min('medium')`
        height: ${rems(50)};
        width: ${rems(50)};
      `}

      .svg {
        path {
          fill: ${colors.neutral[800]};
        }
      }
    }

    &_image {
      width: 100%;
    }
  }

  .bottom {
    ${fonts.bodyMD};
    align-items: center;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 80%);
    bottom: 0;
    color: ${colors.neutral[100]};
    display: flex;
    justify-content: center;
    line-height: 1.1;
    padding: ${space(2)} ${space()};
    position: absolute;
    text-align: center;
    width: 100%;
  }

  ${media.min('medium')`
    margin: 2px;
    width: calc(25% - ${space(0.5)});

    .top {
      margin-bottom: 0;
        &_clickable {
            flex: 1;
            cursor: pointer;
        }
    }

    &:nth-child(1):nth-last-child(3),
    &:nth-child(2):nth-last-child(2),
    &:nth-child(3):nth-last-child(1) {
        width: calc(33.3333% - ${space(1)});
        margin-bottom: 0;
    }
  `}
`;

const VrContainer = styled.div<{
  ratio: number;
}>`
  margin: ${space(8)} auto 0 auto;
  max-height: 640px;
  overflow: hidden;
  padding: 0;
  position: relative;
  width: 100%;

  &:after {
    display: block;
    content: '';
    padding-bottom: ${({ ratio }) => `${100 / ratio}%`};
  }

  .overlay {
    background: transparent;
    height: 100%;
    position: absolute;
    width: 100%;
    z-index: 5;
  }

  .overlay.interactive {
    pointer-events: none;
  }

  .vr {
    position: absolute;
    height: 100%;
    width: 100%;

    iframe {
      height: 100%;
      width: 100%;
    }
  }
`;

const Visualizer = styled.div`
  align-items: center;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 2500;

  .main {
    align-items: center;
    display: flex;
    height: 70%;
    justify-content: space-between;
    margin: 0 auto;
    max-height: 618px;
    max-width: 1100px;
    width: 100%;

    &_circle {
      align-items: center;
      background: ${({ theme }) => theme.background};
      border-radius: 50%;
      display: flex;
      height: 24px;
      justify-content: center;
      width: 24px;

      .svg {
        display: block;
        height: ${rems(8)};
        transform: rotate(90deg);
        width: ${rems(12)};

        path {
          fill: ${({ theme }) => theme.clickable};
        }
      }

      .right {
        transform: rotate(270deg);
      }

      &:hover {
        background: rgba(255, 255, 255, 0.8);
        cursor: pointer;
      }
    }

    &_middle {
      align-items: center;
      display: flex;
      justify-content: center;
      width: 94%;
      position: relative;

      .image {
        width: 100%;
      }

      .close {
        align-items: center;
        background: rgba(255, 255, 255, 0.5);
        border-radius: 50%;
        display: flex;
        height: 24px;
        justify-content: center;
        position: absolute;
        right: 0;
        top: -${space(4)};
        width: 24px;
        z-index: 5;

        ${media.between('large', 'xxlarge')`
          @media (max-height: 720px) {
            right: -${space(4)};
            top: ${space(4)};
          }
        `}

        .svg {
          display: block;
          height: ${rems(8)};
          width: ${rems(8)};

          path {
            fill: #303030;
          }
        }

        &:hover {
          background: rgba(255, 255, 255, 0.65);
          cursor: pointer;
        }
      }
    }
  }
`;

export { Module, Container, Item, VrContainer, Visualizer };
